var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V18H24V0H0ZM15 2H16V7H15V2ZM6 2H7V7H6V2ZM4 5H3V2H4V5ZM8 15H6.646V11.111H5.158V10.111C6.051 10.07 6.859 9.91 6.859 9H8V15ZM10 5H9V2H10V5ZM13 5H12V2H13V5ZM17 14.974H13.078V14.016C14.607 12.525 15.457 11.772 15.467 10.998C15.467 10.536 15.199 10.281 14.713 10.281C14.26 10.281 13.897 10.526 13.545 10.805L13.121 9.657C13.666 9.204 14.312 9 14.954 9C16.133 9 16.895 9.74 16.895 10.885C16.895 12.04 15.996 12.927 15.173 13.667H17V14.974ZM19 5H18V2H19V5ZM22 5H21V2H22V5Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_802:4124",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AA047"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.34d266ba70f4e2d401aea8af63f4f0c0.svg";
export { ForwardRef as ReactComponent };